import type { PopupConfig } from '@coorum-research/shared-common/types/popup.type'
import type { RefObject } from 'react'
import { LauncherPopupRound } from './LauncherPopupRound'
import { LauncherPopupSquare } from './LauncherPopupSquare'

type Props = {
  ref?: RefObject<HTMLDivElement | null>
  configJson?: PopupConfig | null
  onClick?: () => void
  onClose?: () => void
  isEmbed?: boolean
}

export function LauncherPopup({ ref, configJson, onClick, onClose, isEmbed }: Props) {
  return (
    <>
      {(configJson?.buttonType === 'round') && (
        <LauncherPopupRound
          ref={ref}
          configJson={configJson}
          onClick={onClick}
          onClose={onClose}
          isEmbed={isEmbed}
        />
      )}
      {(configJson?.buttonType === 'square') && (
        <LauncherPopupSquare
          ref={ref}
          configJson={configJson}
          onClick={onClick}
          onClose={onClose}
          isEmbed={isEmbed}
        />
      )}
    </>
  )
}
